import StorageDetail from "../../../storages/StorageDetail"

export const OpenStorageDetail = () => {
  return (
    <StorageDetail />
  )
}
